import { defineMessage } from '@lingui/macro';

const TIMESHEET_REASON_EARLY_START = 'TIMESHEET_REASON_EARLY_START',
  TIMESHEET_REASON_LATE_QUIT = 'TIMESHEET_REASON_LATE_QUIT',
  TIMESHEET_REASON_WORK_THRU_LUNCH = 'TIMESHEET_REASON_WORK_THRU_LUNCH',
  TIMESHEET_REASON_EXCUSED_JURY_DUTY_MILITARY = 'TIMESHEET_REASON_EXCUSED_JURY_DUTY_MILITARY',
  TIMESHEET_REASON_TRAINING = 'TIMESHEET_REASON_TRAINING',
  TIMESHEET_REASON_OTHER = 'TIMESHEET_REASON_OTHER';

export const CommentMessages = {
  [TIMESHEET_REASON_EARLY_START]: defineMessage({ message: `Early Start` }),
  [TIMESHEET_REASON_LATE_QUIT]: defineMessage({ message: `Late Quit` }),
  [TIMESHEET_REASON_WORK_THRU_LUNCH]: defineMessage({
    message: `Work Thru Lunch`,
  }),
  [TIMESHEET_REASON_EXCUSED_JURY_DUTY_MILITARY]: defineMessage({
    message: `Excused Jury Duty Military`,
  }),
  [TIMESHEET_REASON_TRAINING]: defineMessage({ message: `Training` }),
  [TIMESHEET_REASON_OTHER]: defineMessage({ message: `Other` }),
};
